import { QueryClient } from "react-query";
import { store } from "../store";
import { resetAuthState } from "@funded-here-interface/common/src/features/auth/authSlice_Admin";

const handleOnError = (message: string) => {
  if (message === "Unauthorized") {
    store.dispatch(resetAuthState());
    window.location.replace("/login");

    return;
  }
};

const client = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (e) => {
        handleOnError((e as Error).message);
      },
    },
    queries: {
      onError: (e) => {
        handleOnError((e as Error).message);
      },
    },
  },
});

export { client };
